export const starLevelMap = {
  '1': '很差',
  '2': '不满意',
  '3': '一般',
  '4': '比较满意',
  '5': '非常满意'
}

export const efficacyEvaluationMap = {
  '1': '症状加重',
  '2': '无改善',
  '3': '有点改善',
  '4': '有明显改善',
  '5': '已痊愈'
}

export const recommendationIndexMap = {
  '1': '不推荐',
  '2': '稍微推荐',
  '3': '值得一试',
  '4': '非常推荐',
  '5': '强烈推荐'
}
